jQuery(document).ready(function ($) {
  $('[data-affix=true]').affix({
    offset: {
      top: function () {
        return window.matchMedia ?
          (window.matchMedia('min-width: 768px').matches ? 60 : 110)
          : 60;
      }
    }
  });
});
